// @ts-nocheck
import React, { Fragment } from "react"
import styles from "./styles"
import Stack from "@mui/material/Stack"

export default function PageContainer({ mounted, sx, children }) {
	if (mounted) return <Stack sx={{ ...styles.container, ...sx }}>{children}</Stack>
	else return <Fragment />
}
